/**
 * External URLs and API paths used across the application
 */

export const DEFAULT_OG_IMAGE_URL = 'https://cemkoyluoglu.tech/og-image.png';

export const GOOGLE_MAPS_DUBLIN_URL = 'https://www.google.com/maps/place/Dublin,+Ireland';

export const TWITTER_WIDGET_SCRIPT_URL = 'https://platform.twitter.com/widgets.js';

export const TIKTOK_EMBED_SCRIPT_URL = 'https://www.tiktok.com/embed.js';

export const YOUTUBE_EMBED_BASE_URL = 'https://www.youtube.com/embed';

export const WSRV_CDN_BASE_URL = 'https://wsrv.nl/';

export const TECH_NEWS_API_BASE = '/api/tech-news';

export const PROJECT_URLS = {
  deepfakeGithub: 'https://github.com/CemRoot/deepfake-detection-streamlit',
  deepfakeDemo: 'https://deepfake-detection-app-4ogcgzlgv7n9yuncblpz2r.streamlit.app/',
  irelandExpatAssistant: 'https://chatgpt.com/g/g-693c3f003b308191a3aa51cf1e75e47e-ireland-expat-assistant',
  youtubeAiSummarizerStore:
    'https://chromewebstore.google.com/detail/youtube-ai-summarizer/dkbgkfeobjailmeiaidmapifohkjpgji?authuser=0&hl=en',
  youtubeAiSummarizerGithub: 'https://github.com/CemRoot/yt-ai-summarizer',
} as const;

/** Springer CCIS volume — AICS 2025 proceedings (book DOI landing page). */
export const SPRINGER_CCIS_BOOK_URL = 'https://link.springer.com/book/9783032258083';
